export enum Type { Model = 'Model', Item = 'Item', PartnerId = 'PartnerId', Sku = 'Sku' }

export function valueOf(type: string) : Type {
  if(type === 'Model'){
    return Type.Model;
  }
  return Type.Item;
}
